var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material-datatables"},[_c('table',{staticClass:"table table-striped trax-table",staticStyle:{"width":"100%"},attrs:{"id":_vm.id+'-table',"width":"100%"}},[(_vm.header)?_c('thead',[_c('tr',_vm._l((_vm.titles),function(title,index){return _c('th',{key:index},[_vm._v(" "+_vm._s(title)+" ")])}),0)]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }